import React from 'react';
import './index.css';
import 'react-calendar/dist/Calendar.css';
import { Item, Value } from '../../types';
import { formatExtendedDate } from '../../utils';
import ScheduleItem from '../ScheduleItem';
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'


const Schedule = ({ date, items, loading, onChange, urlContext }: { items: Item[], date: Value, loading: boolean, onChange: React.Dispatch<React.SetStateAction<Value>>, urlContext: string | null }) => {

    const handleDayClick = (type: string = "INCREMENT") => {
        if (!(date instanceof Date)) return;

        const increment = type === "INCREMENT" ? 1 : -1;
        const nextDay = new Date(date);
        nextDay.setDate(date.getDate() + increment);
        onChange(nextDay);
    };

    const prevDate = new Date(date instanceof Date ? date : new Date());
    prevDate.setDate(prevDate.getDate() - 1);

    const nextDate = new Date(date instanceof Date ? date : new Date());
    nextDate.setDate(nextDate.getDate() + 1);

    return (
        <div>
            <div className="psp-section-title">
                <div className="psp-section-title__main mr-5">
                    <div className="psp-section-title__icon text-7 mr-5">
                        <i className="psp-icon-calendar"></i>
                    </div>
                    <div className="psp-section-title__text text-6 font-weight-semi-bold">
                        Programação da agenda
                    </div>
                </div>
                <div className="psp-section-title__divider d-none d-sm-block"></div>
            </div>
            <p className='psp-calendar-subtitle mt-3'>{formatExtendedDate(date)}</p>
            <div className='psp-calendar-container'>
                {!loading ?
                    (
                        <div>
                            {items.length > 0 ? (
                                <div>
                                    {items.map(item => <ScheduleItem key={item.id} item={item} urlContext={urlContext} />)}
                                </div>
                            ) : (
                                <p className="psp-calendar-not-found"><i className="material-icon">event_busy</i> <span>Sem compromissos oficiais neste dia.</span></p>
                            )}
                        </div>
                    )
                    :
                    <div>
                        {Array.from({ length: 5 }, (_, idx) => (
                            <div key={idx} className="psp-skeleton-calendar-mayor">
                                <Skeleton height={"20px"} />
                                <Skeleton width={"150px"} />
                            </div>
                        ))}
                    </div>}
            </div>
            <div className="psp-calendar-actions-arrows mt-5">
                <div>
                    <button className="psp-calendar-actions-arrows-button" onClick={() => handleDayClick("DECREMENT")}><i className="material-icon">arrow_back</i><span>Dia anterior</span></button>
                    <span className="psp-calendar-actions-arrows-date">{formatExtendedDate(prevDate)}</span>
                </div>
                <div>
                    <button className="psp-calendar-actions-arrows-button" onClick={() => handleDayClick("INCREMENT")}><span>Próximo dia</span><i className="material-icon">arrow_forward</i></button>
                    <span className="psp-calendar-actions-arrows-date">{formatExtendedDate(nextDate)}</span>
                </div>
            </div>
        </div>
    );
}

export default Schedule
